const termType = 'users&advisors';

const isWorkForce = (terms) => {
    if (!terms || typeof terms !== 'string') {
        return false;
    }
    return termType === terms.toLowerCase().replace(/\s+/g, '');
};

module.exports = isWorkForce;



// WEBPACK FOOTER //
// ./src/client/utils/isWorkForce.js